export default {
  methods: {
    showToast(variant = null, title = 'Notification', text = 'something to notify') {

      const icons = {
        'null': 'question',
        success: 'check',
        danger: 'exclamation',
        warning: 'exclamation',
        info: 'info'
      };

      const icon = icons[variant] || "check";

      // Create the message
      const toastBodyText = this.$createElement(
        'p',
        { class: ['text-center', 'mb-0'] },
        [
          this.$createElement('font-awesome-icon', {
            props: {
              icon: icon, fixedWidth: true
            }
          }),
          " " + text,
        ]
      );

      this.$bvToast.toast([toastBodyText], {
        title: title,
        variant: variant,
        toaster: "b-toaster-top-center",
        solid: true,
        bodyClass: "text-center",
        // autoHideDelay: 50000,
      });

    }
  }
}